export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    return location.hash !== "#hsform";
};

let loaderTimer = null;
let routeLoaderTimer = null;
let routeLoading = false;

export const onClientEntry = () => {
    showGlobalLoader();

    waitForInitialPaintReady()
        .then(() => hideGlobalLoader())
        .catch(() => hideGlobalLoader());

    const dl = (window.dataLayer = window.dataLayer || []);
    const originalPush = dl.push.bind(dl);

    dl.push = function () {
        for (const a of arguments) {
            if (!a || !a.event) continue;

            if (a.event === "consent_accepted_analytics") {
                loadYandexMetrikaTag(74102173);
                loadGTM("GTM-NH6G7LG");
            }

            if (a.event === "consent_accepted_advertising") {
                loadGTM("GTM-NH6G7LG");
            }
        }

        return originalPush.apply(null, arguments);
    };
};

export const onPreRouteUpdate = () => {
    routeLoading = true;

    clearTimeout(routeLoaderTimer);
    routeLoaderTimer = setTimeout(() => {
        if (routeLoading) {
            showGlobalLoader();
        }
    }, 500);
};

export const onRouteUpdate = ({ location }) => {
    if (location.hash === "#hsform") {
        const el = document.getElementById("hsform");
        if (el) {
            const headerOffset = 120;
            const y =
                el.getBoundingClientRect().top +
                window.pageYOffset -
                headerOffset;

            window.scrollTo({ top: y, behavior: "smooth" });
        }
    }

    routeLoading = false;
    clearTimeout(routeLoaderTimer);

    waitForRoutePaintReady()
        .then(() => hideGlobalLoader())
        .catch(() => hideGlobalLoader());
};

function waitForInitialPaintReady() {
    return waitForPaintReady({ minShowMs: 250, maxWaitMs: 8000 });
}

function waitForRoutePaintReady() {
    return waitForPaintReady({ minShowMs: 200, maxWaitMs: 6000 });
}

function waitForPaintReady({ minShowMs, maxWaitMs }) {
    const start = performance.now();

    const minDelay = new Promise((r) => setTimeout(r, minShowMs));

    const rafStable = new Promise((resolve) => {
        requestAnimationFrame(() =>
            requestAnimationFrame(resolve)
        );
    });

    const imagesReady = waitForImagesInDOM(maxWaitMs);

    const fontsReady =
        document.fonts && typeof document.fonts.ready?.then === "function"
            ? Promise.race([document.fonts.ready, timeout(maxWaitMs)])
            : Promise.resolve();

    const hardTimeout = timeout(maxWaitMs);

    return Promise.race([
        Promise.all([minDelay, rafStable, imagesReady, fontsReady]),
        hardTimeout,
    ]).then(() => {
        const elapsed = performance.now() - start;
        if (elapsed >= minShowMs) return;
        return new Promise((r) =>
            setTimeout(r, minShowMs - elapsed)
        );
    });
}

function waitForImagesInDOM(maxWaitMs) {
    const imgs = Array.from(document.images || []);
    if (!imgs.length) return Promise.resolve();

    const needWait = imgs.filter((img) => {
        if (img.complete && img.naturalWidth > 0) return false;
        return true;
    });

    if (!needWait.length) return Promise.resolve();

    return Promise.race([
        Promise.all(
            needWait.map(
                (img) =>
                    new Promise((resolve) => {
                        const done = () => {
                            img.removeEventListener("load", done);
                            img.removeEventListener("error", done);
                            resolve();
                        };
                        img.addEventListener("load", done, { once: true });
                        img.addEventListener("error", done, { once: true });
                    })
            )
        ),
        timeout(maxWaitMs),
    ]);
}

function timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

function showGlobalLoader() {
    if (document.getElementById("global-loader")) return;

    const el = document.createElement("div");
    el.id = "global-loader";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");

    el.innerHTML = `
    <div class="global-loader__backdrop">
      <div class="global-loader__spinner"></div>
    </div>
  `;

    document.body.appendChild(el);
}

function hideGlobalLoader() {
    const el = document.getElementById("global-loader");
    if (!el) return;

    el.classList.add("global-loader--hide");

    clearTimeout(loaderTimer);
    loaderTimer = setTimeout(() => {
        const node = document.getElementById("global-loader");
        if (node) node.remove();
    }, 200);
}

function loadScript(src, id) {
    if (id && document.getElementById(id)) return;

    const s = document.createElement("script");
    if (id) s.id = id;
    s.src = src;
    s.async = true;
    document.head.appendChild(s);
}

function loadGTM(containerId) {
    if (document.getElementById("gtm-js")) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
    });

    const gtm = document.createElement("script");
    gtm.id = "gtm-js";
    gtm.async = true;
    gtm.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
    document.head.appendChild(gtm);
}

function loadYandexMetrikaTag(counterId) {
    if (document.getElementById(`ym-tag-${counterId}`)) return;

    if (!document.getElementById("yandex-metrika-lib")) {
        loadScript(
            "https://mc.yandex.ru/metrika/tag.js",
            "yandex-metrika-lib"
        );
    }

    const triesMax = 100;
    let tries = 0;

    const t = setInterval(() => {
        tries += 1;

        if (typeof window.ym === "function") {
            const marker = document.createElement("meta");
            marker.id = `ym-tag-${counterId}`;
            document.head.appendChild(marker);

            window.ym(counterId, "init", {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true,
            });

            clearInterval(t);
        } else if (tries >= triesMax) {
            clearInterval(t);
        }
    }, 50);
}